import { MemberDetailsProvider } from './Component/Context/MemberDetails';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { TokenProvider } from "./Component/Context/useToken";
import { ThemeProvider } from "styled-components";
import theme from "./Component/tool/mediasize";

import { startDeploymentRefresh } from "./Component/tool/deploymentRefresh";

import { initializeAppearance } from "./Component/UI/useAppearance";

initializeAppearance();
if (process.env.NODE_ENV === "production") startDeploymentRefresh();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

interface ProviderConfig {
  Provider: React.ComponentType<any>;
  props?: any;
}
interface AppProviderProps {
  contexts: ProviderConfig[];
  children: React.ReactNode;
}
const AppProvider: React.FC<AppProviderProps> = ({ contexts, children }) =>
  contexts.reduce<React.ReactElement | null>(
    (prev, { Provider, props }) =>
      React.createElement(Provider, {
        ...props, // Provider에 props 전달
        children: prev,
      }),
    children as React.ReactElement
  );

root.render(
  <BrowserRouter basename="">
    <React.StrictMode>
      <AppProvider
        contexts={[
          { Provider: TokenProvider },
          { Provider: ThemeProvider, props: { theme } },
        ]}
      >
        <MemberDetailsProvider><App /></MemberDetailsProvider>
      </AppProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
